module.exports = require("./ar-LB.d.ts");